import { useHandleSubmit } from "features/dt-basic-setup/single-building/components/action/hooks/useHandleSubmit";
import { SingleBuildingContext } from "features/dt-basic-setup/single-building/context/AddSingleBuildingContext";
import { LAST_FORM_STEP_NO, STEP } from "features/dt-basic-setup/single-building/model/constants";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { isFormFilled } from "../lib/createSubmitAction";

export const useActionLogic = () => {
  const { t } = useTranslation();
  const { canExecuteDTCreation, formData, jobId, projectId, setStepNo, stepNo } = useContext(SingleBuildingContext);

  const { handleSaveAndExit, handleSubmit, isSubmitting, modalActionButton, submitInfo, submitModalOpen } =
    useHandleSubmit(projectId);

  const showBackButton = stepNo > 0;
  const goToNextStep = () => setStepNo(Math.min(stepNo + 1, STEP.final));

  const onBack = () => {
    setStepNo(stepNo - 1);
  };

  const canSubmitDTCreation = canExecuteDTCreation && !jobId;
  const showDTCreationButton = stepNo === LAST_FORM_STEP_NO && canSubmitDTCreation;

  const actionButtonsDifferentProps = showDTCreationButton
    ? {
        nextButtonText: t("AddBuilding.actionButtons.submit"),
        onNext: handleSubmit,
      }
    : {
        nextButtonText: t("general.next"),
        onNext: goToNextStep,
      };

  const isActionAllowed = !isSubmitting && !isFormFilled(formData, projectId);

  const actionButtonsProps = {
    ...actionButtonsDifferentProps,
    isNextButtonDisabled: isActionAllowed,
    isSaveButtonDisabled: isActionAllowed,
    onBack,
    onSaveAndExit: handleSaveAndExit,
    showBackButton,
    showSaveAndExit: !jobId,
  };

  return {
    actionButtonsProps,
    modalActionButton,
    submitInfo,
    submitModalOpen,
  };
};
